/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';
import { UpdateInventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersUpdateInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/update-inventory-stock-transfer-dto';

export interface UpdateStockTransfer$Params {
  inventoryId: string;
  transferId: string;
      body?: DigiworkMaitreDPosDtoInventoryStockTransfersUpdateInventoryStockTransferDto
}

export function updateStockTransfer(http: HttpClient, rootUrl: string, params: UpdateStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
  const rb = new RequestBuilder(rootUrl, updateStockTransfer.PATH, 'put');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('transferId', params.transferId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>;
    })
  );
}

updateStockTransfer.PATH = '/api/inventories/{inventoryId}/transfers/{transferId}';
